// extracted by mini-css-extract-plugin
module.exports = {"spinner":"tArSx3","spiinerAnimateSvg":"AnJBIV","spinnerAnimateCircle":"O2st3T","spinnerSm":"c8gL-2M","spinnerMd":"n-y1Vo","spinnerLg":"ollPPS","spinnerAuto":"c_dItQ0"};